import { Component } from 'preact'

/*
PROPS
default: string [optional]
  State Name i.e. "Michigan"

default: string [optional]
  4 digits, MMDD i.e. 0310
*/

export class ApMaps extends Component {
  componentWillMount() {
    this.maps_0310 = [
      {
        name: 'Idaho',
        src: 'https://elections.ap.org/widgets/content/b91cdfa523eb8d148a52825ab44798d0',
      },
      {
        name: 'Michigan',
        src: 'https://elections.ap.org/widgets/content/f92418afb9905c48ed40bcfc998ee838',
      },
      {
        name: 'Mississippi',
        src: 'https://elections.ap.org/widgets/content/3daf1f541efbbec72fb05c65dde60c1f',
      },
      {
        name: 'Missouri',
        src: 'https://elections.ap.org/widgets/content/c69879b6526dd838d4d0cc7e5f13fae7',
      },
      {
        name: 'North Dakota',
        src: 'https://elections.ap.org/widgets/content/e6ea22ac9bf66b06500b0f113f2557da',
      },
      {
        name: 'Washington',
        src: 'https://elections.ap.org/widgets/content/f6a6926daf1983a61b74d736f063d052',
      },
    ]

    this.maps_0317 = [
      {
        name: 'Arizona',
        src: 'https://elections.ap.org/widgets/content/cdb9346a877358cdb0c5f0a89a886133',
      },
      {
        name: 'Florida',
        src: 'https://elections.ap.org/widgets/content/fa1976d7f540ec504a9b2fea43006a13',
      },
      {
        name: 'Illinois',
        src: 'https://elections.ap.org/widgets/content/db22cec7b0d51c48d566cedaeff586d5',
      },
      // {
      //   name: 'Ohio',
      //   src:
      //     'https://elections.ap.org/widgets/content/1967e0e9e53d5423b846545d52144d87',
      // },
    ]

    if (this.props.date && this[`maps_${this.props.date}`])
      this.maps = this[`maps_${this.props.date}`]
    else this.maps = this.maps_0310

    //cant use state b/c iFrameResizer wont set up a frame with the same id twice/
    //and re-rendering requires that. This was quicker than scouring thier docs
    //and honestly i dont really care if this code is good
    this.activeMap = 0
    let defaultMap = -1
    if (this.props.default) {
      this.maps.forEach((map, i) => {
        if (map.name === this.props.default) defaultMap = i
      })
    }
    this.defaultMap = defaultMap
  }

  componentDidMount() {
    //global var necessary
    window['scriptListenerInterval' + this.id] = null
    this.appendScript()
  }

  componentDidUpdate() {
    this.resize()
  }

  appendScript() {
    if (!window.iFrameResize) {
      var scriptTag = document.createElement('script')
      scriptTag.type = 'text/javascript'
      scriptTag.src =
        'https://elections.ap.org/widgets/js/resizer.client.min.js'
      scriptTag.async = true
      document.body.appendChild(scriptTag)
    }
    this.scriptListener()
  }

  resize() {
    if (window.iFrameResize) {
      this.maps.forEach((map, i) => {
        window.iFrameResize({}, `#MapFrame_${i}`)
      })
    }
  }

  scriptListener() {
    const self = this
    window['scriptListenerInterval' + this.id] = setInterval(function () {
      if (window.iFrameResize) {
        self.stopScriptListener()
      }
    }, 1000)
  }

  stopScriptListener() {
    clearInterval(window['scriptListenerInterval' + this.id])
    this.setState({ hasScript: true })
  }

  toggle(i) {
    //setting this here does nothing but let me easily see what
    //state would be if i was using it
    this.activeMap = i

    document.querySelectorAll('.js_apmap, .js_apmapbutton').forEach((el) => {
      el.classList.remove('--active')
    })

    document
      .querySelectorAll(`.js_apmap${i}, .js_apmapbutton${i}`)
      .forEach((el) => {
        el.classList.add('--active')
      })
  }

  renderButtons() {
    const self = this
    return this.maps.map((map, i) => {
      let isActive = this.activeMap === i
      //use the default map if prop
      if (this.defaultMap > -1) isActive = this.defaultMap === i

      return (
        <button
          onClick={() => {
            self.toggle(i)
          }}
          class={`js_apmapbutton js_apmapbutton${i} ApMaps__Button ${
            isActive ? '--active' : ''
          }`}
        >
          <i class="far fa-circle not-selected"></i>
          <i class="fad fa-circle selected"></i>
          {' ' + map.name}
        </button>
      )
    })
  }

  renderMaps() {
    if (!this.state.hasScript) return

    return this.maps.map((map, i) => {
      let isActive = this.activeMap === i
      //use the default map if prop
      if (this.defaultMap > -1) isActive = this.defaultMap === i
      return (
        <div
          class={`js_apmap js_apmap${i} ApMaps__Map ${
            isActive ? '--active' : ''
          }`}
        >
          {' '}
          <div class="ApMaps__MapInner">
            <iframe
              id={`MapFrame_${i}`}
              style={
                'overflow: hidden; min-width: 100%; border: none; margin: initial!important'
              }
              src={map.src}
              width="100%"
              height="100%"
              frameborder="1"
              allowfullscreen="allowfullscreen"
              onload={() => {
                window.iFrameResize({ log: true }, `#MapFrame_${i}`)
              }}
            ></iframe>
          </div>
        </div>
      )
    })
  }

  render() {
    return (
      <div class="ApMaps">
        <div class="ApMaps__Buttons">{this.renderButtons()}</div>
        <div class="ApMaps__Maps">{this.renderMaps()}</div>
      </div>
    )
  }
}
